import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as CloseBtn } from '../../../../assets/icons/close.svg';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import BlackButton from '../../../../components/BlackButton';
import init from '../../AccessControl/Check';
import { useRef } from 'react';
import $ from 'jquery';
import { MAX_UPLOAD_FILE_SIZE } from '../../../../components/Constants/FileUpload';

const EditVoucherCategory = () => {

    const pageName = "Voucher Category Update";
    const isAccess = init(pageName);

    const state = useLocation();
    const navigate = useNavigate();
    const [id, setId] = useState("");

    const fileInput = useRef();
    const [file, setFile] = useState("");
    
    const selectFile = () => {
        fileInput.current.click();
    }
    
    const handleChangeFile = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }
        
        setFile(e.target.files[0]);
    }

    const cancelFile = () => {
        setFile();
        fileInput.current.value = "";
    }

    const [input, setInput] = useState({
        name: "",
        position: ""
    });

    const handleChange = (evt) => {
        const value = evt.target.value;


        if( evt.target.name === "position" ) {
            const re = /^[0-9]*?$/;
            if(!re.test(value)) {
                return;
            }

            if( parseInt(value) > 9999 ) {
                return;
            }
        }

        setInput({
            ...input, [evt.target.name]: value
        });
    }

    const onSubmit = (e) => {
        e.preventDefault();

        if (id === "") {
            toast.error("No voucher category id found.");
            return;
        }

        if (input?.name === "") {
            toast.error("Please enter category name.");
            return;
        }

        
        if (input?.position === "") {
            toast.error("Please enter category display position.");
            return;
        }

        let requestBody = new FormData();
        requestBody.append("name", input.name);
        requestBody.append("position", input.position ?? null);

        if(file !== null && file !== undefined && file !== "") {
            requestBody.append("icon", file);
        }


        // Update Voucher Category API
        PostLoginPostApi("voucher/category/update/" + id, requestBody, 3, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Voucher Category updated successfully.");
                    navigate("/dashboard/category", {
                        state: {
                            tab: "VoucherCategory"
                        }
                    });
                    return;
                }

                toast.error("A problem occur. Please try again.");
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        if (state?.state?.data?.id === undefined) {
            return navigate("/dashboard/category", {
                state: {
                    tab: "VoucherCategory"
                }
            });
        }

        if (state?.state?.data?.name === undefined) {
            return navigate("/dashboard/category", {
                state: {
                    tab: "VoucherCategory"
                }
            });
        }

        if (state?.state?.data?.position === undefined) {
            return navigate("/dashboard/category", {
                state: {
                    tab: "VoucherCategory"
                }
            });
        }

        setId(state.state.data.id);
        setInput({...input, name: state.state.data.name, position: state.state.data.position});

    }, [state]);


    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }


    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <header className="p-4 border-b-2 border-dark-white mb-[60px]">
                <Link to="/dashboard/category" state={{ tab: "VoucherCategory" }}><CloseBtn className="float-left" /></Link>
                <p className="text-center text-lg">Edit voucher category</p>
            </header>
            <main className="max-w-2xl m-auto">


                <form onSubmit={onSubmit}>
                    <div className="relative pb-2 pt-1 mb-[15px]">
                        <input type="text" name="name" id="name" placeholder=" " value={input.name} onChange={handleChange} className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />
                        <label htmlFor="name" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Voucher Category Name *</label>
                    </div>


                    <div className="flex pb-2 pt-1 mb-6 items-center">
                        <div className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0" }}>
                            <input type="file" className="hidden" name="icon" ref={fileInput} onChange={handleChangeFile} />
                            <label htmlFor="icon" className="p-1 text-base font-medium">Icon</label>
                            {file ?
                                <>
                                    <img src={URL.createObjectURL(file)} alt="Preview Icon" className="max-h-10 max-w-[70px] ml-auto order-3" />
                                    <p style={{ fontSize: "10px" }} onClick={() => cancelFile()} className="text-red-700 font-semibold cursor-pointer">cancel</p>
                                    <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[50px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile}>Change</button>
                                </> :
                                <>
                                    <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base" onClick={selectFile}>Update</button>
                                </>
                            }

                        </div>

                        <div className="relative w-[49.5%] p-2 rounded-md ml-auto">
                            {(state?.state?.data?.icon) && 
                                <img src={state?.state?.data?.icon} alt="Voucher Category Icon" className="float-left max-h-10 max-w-10 ml-auto order-3" />
                            }
                        </div>
                    </div>


                    
                    <div className="relative pb-2 pt-1 mb-4">
                        <input type="text" name="position" placeholder=" " value={input.position} onChange={handleChange} className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                        <label htmlFor="position" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Display Position *</label>
                    </div>
                    

                    <BlackButton name="Update voucher category" />
                </form>

            </main>
        </div>
    );
};

export default EditVoucherCategory;